import React, { useContext } from "react";

import classNames from "classnames";
import { observer } from "mobx-react";
import Image from "next/legacy/image";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";

const StyledFlexibleImageWrapper = styled.div`
  max-width: ${({ $maxWidth }) => $maxWidth || "150px"};
  //min-height: ${({ $height }) => $height || "150px"};
`;
function FlexibleImage() {
  const { maxWidth, image, alignImage } = useContext(ComponentContext);

  const imageWrapperClassName = classNames({
    "m-auto": alignImage === "center",
    "me-auto": alignImage === "left",
    "ms-auto": alignImage === "right",
  });

  return (
    <StyledFlexibleImageWrapper
      $maxWidth={maxWidth}
      className={imageWrapperClassName}
    >
      <Image
        alt={image?.alternativeText}
        height={image?.height}
        layout="responsive"
        priority
        src={image?.url}
        width={image?.width}
      />
    </StyledFlexibleImageWrapper>
  );
}

export default observer(FlexibleImage);
